// @flow

export const roundNumber = (price: number, maxDecimals = 2) =>
  Math.round((price + Number.EPSILON) * (10 ** maxDecimals)) / (10 ** maxDecimals);
